export default function Account() {
    return (
        <article className="article">
            <h1>My Account</h1>
        </article>
    )
}
